import React from "react";
import ListHeader from "../../molecules/ListHeader/ListHeader";
import { CameraIcon } from "../../assets/icons";
import { useSelector } from "react-redux";

const UserProfile = () => {
  const { user } = useSelector((state) => state.auth);

  return (
    <div className="w-full flex flex-col pb-12">
      <ListHeader
        mainHeading="Profile"
        searchShow={false}
        showLikeFilter={false}
        DropDown={false}
      />
      <div className="flex py-2 w-full min-h-screen">
        <div className="px-6 pt-3 w-full h-[324px] bg-white border border-[#DDDDDD] rounded-[8px]">
          <div className="flex flex-col items-center">
            <div className="relative">
              {user?.user?.image ? (
                <img
                  className="w-[120px] h-[120px] rounded-full bg-[#D9D9D9] object-cover"
                  src="https://via.placeholder.com/150"
                  alt="Profile"
                />
              ) : (
                <div className="w-[120px] h-[120px] rounded-full bg-[#D9D9D9] object-cover"></div>
              )}
              <div className="absolute bottom-[2px] right-[4px] rounded-full p-1">
                <span className="text-sm">{CameraIcon}</span>
              </div>
            </div>
          </div>

          <div className="mt-6">
            <input
              type="text"
              placeholder="Mike Morgan"
              className="w-full p-3 border rounded-md h-[52px] focus:outline-none "
              value={user?.user?.username}
            />
          </div>

          <div className="mt-4 flex space-x-4">
            <input
              type="email"
              placeholder="abc@gmail.com"
              className="flex-1 p-3 border rounded-md h-[52px] focus:outline-none "
              value={user?.user?.email}
            />
            <div className="relative flex-1">
              <input
                type="password"
                placeholder="abn123"
                className="w-full p-3 border rounded-md h-[52px] focus:outline-none "
                value={user?.user?.password}
              />
              <div className="absolute inset-y-0 right-3 flex items-center">
                {/* <button>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 12l-3-3m0 0l-3 3m3-3v12m9-12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
